import {isNullOrUndefined} from "util";

export const makeJsonData = ({
   name,
   visibility,
   email,
   detail,
   client,
   type,
   googleAnalyticsId,
   googleTagManagerId,
   customUrl,
   channelContentCreatorTypes,
   translations,
   catalogs,
   socialLinks,
   imageId,
   loginImageId,
   faviconId,
   showBanner,
   showAdvancedSearch,
   showSupport,
   showAbout,
   tags,
   navbarElements,
   navbarElementsToDelete,
   binaryId,
   policyId,
   bloomcloudChannel,
   loginType,
   language,
   canDownloadTracks,
   keywordsSEO,
   descriptionSEO,
   tagGroups,
   supportNegativeSearch,
   trackingGroup,
   showLoginButton,
   preRollVideoId,
 }) => {
  const form = new FormData();

  if (name) form.append("name", name);
  if (visibility) form.append("visibility", visibility)
  if (type) form.append("type", type);
  if (!isNullOrUndefined(email)) form.append("email", email);
  if (detail) form.append("detail", detail);
  if (client) form.append("client_id", client.value);
  if (!isNullOrUndefined(googleAnalyticsId)) form.append("google_analytics_id", googleAnalyticsId);
  if (!isNullOrUndefined(googleTagManagerId)) form.append("google_tag_manager_id", googleTagManagerId);
  if (catalogs) catalogs.forEach(x => form.append("catalogs_ids[]", x.value))
  if (navbarElements) navbarElements.forEach(x => form.append("navbar_elements_ids[]", x.id))
  if (navbarElementsToDelete) navbarElementsToDelete.forEach(x => form.append("navbar_elements_ids_to_delete[]", x))
  if (tags) tags.forEach(x => form.append("tags_ids[]", x.value))
  if (!isNullOrUndefined(customUrl)) form.append("domain", customUrl);
  if (showBanner) form.append("show_banner", showBanner);
  if (!isNullOrUndefined(showSupport)) form.append('show_support', showSupport ? 1 : 0)
  if (showAdvancedSearch) form.append('show_advanced_search', showAdvancedSearch)
  if (showAbout) form.append('show_about', showAbout)
  if (showAbout) form.append('login_type', loginType)
  if (!isNullOrUndefined(bloomcloudChannel)) form.append('bloomcloud_channel', bloomcloudChannel ? 1 : 0)
  if (!isNullOrUndefined(canDownloadTracks)) form.append('can_download_tracks', canDownloadTracks ? 1 : 0)
  if (language) form.append('language', language)
  if (!isNullOrUndefined(keywordsSEO)) form.append('seo_keywords', keywordsSEO)
  if (!isNullOrUndefined(descriptionSEO)) form.append('seo_description', descriptionSEO)
  if (!isNullOrUndefined(supportNegativeSearch)) form.append('support_negative_search', supportNegativeSearch)
   if (trackingGroup) form.append('tag_group_tracking', trackingGroup.value)
  if (!isNullOrUndefined(showLoginButton)) form.append('show_login_button', showLoginButton ? 1 : 0)

  if (!isNullOrUndefined(tagGroups)) {
    if (tagGroups.length > 0) {
      tagGroups.forEach((tg, index) => {
        form.append(`tag_groups[${index}][id]`, tg.id);
        form.append(`tag_groups[${index}][view_type]`, tg.view_type);
      });
    }else {
      form.append('tagGroups', 'empty')
    }
  }

  if (!isNullOrUndefined(channelContentCreatorTypes)) {
    if (channelContentCreatorTypes.length > 0) {
      channelContentCreatorTypes.forEach((cr, index) => {
        if (cr.content_creator_type_id !== "music") {
          form.append(`channel_content_creator_types[${index}][content_creator_type_id]`, cr.content_creator_type_id);
          form.append(`channel_content_creator_types[${index}][show_on_global_search]`, cr.show_on_global_search ? 1 : 0);
          form.append(`channel_content_creator_types[${index}][show_on_smart_search]`, cr.show_on_smart_search ? 1 : 0);
          form.append(`channel_content_creator_types[${index}][tracking_tag_group_id]`, cr.tracking_tag_group_id || 0);
        } else {
          form.append(`allow_music`, 1);
          form.append(`show_on_global_search`, cr.show_on_global_search ? 1 : 0);
          form.append(`show_on_smart_search`, cr.show_on_smart_search ? 1 : 0);
        }
      });
      !channelContentCreatorTypes.find(element => element.content_creator_type_id === "music") && form.append(`allow_music`, 0);
    }else {
      form.append('channel_content_creator_types', 'empty')
    }
  }
  if (translations) {
    translations.forEach(translation => {
      if (!isNullOrUndefined(translation.about)) form.append(`translations[${translation.language}][about]`, translation.about);
      if (!isNullOrUndefined(translation.welcome)) form.append(`translations[${translation.language}][welcome]`, translation.welcome);
      if (!isNullOrUndefined(translation.register)) form.append(`translations[${translation.language}][register]`, translation.register)
      if (!isNullOrUndefined(translation.registerConfirmed)) form.append(`translations[${translation.language}][register_confirmed]`, translation.registerConfirmed)
      if (!isNullOrUndefined(translation.registerEvaluating)) form.append(`translations[${translation.language}][register_evaluating]`, translation.registerEvaluating)
      if (!isNullOrUndefined(translation.evaluateApproved)) form.append(`translations[${translation.language}][evaluate_approved]`, translation.evaluateApproved)
      if (!isNullOrUndefined(translation.globalSearchText)) form.append(`translations[${translation.language}][global_search_text]`, translation.globalSearchText)
      if (!isNullOrUndefined(translation.loginRedirectText)) form.append(`translations[${translation.language}][login_redirect_text]`, translation.loginRedirectText)
      if (!isNullOrUndefined(translation.login)) form.append(`translations[${translation.language}][login]`, translation.login)
      if (!isNullOrUndefined(translation.viewsLimit)) form.append(`translations[${translation.language}][views_limit]`, translation.viewsLimit)
      if (!isNullOrUndefined(translation.regionLimit)) form.append(`translations[${translation.language}][region_limit]`, translation.regionLimit)
      if (!isNullOrUndefined(translation.fpsCertificateLimit)) form.append(`translations[${translation.language}][fps_certificate_limit]`, translation.fpsCertificateLimit)
      if (!isNullOrUndefined(translation.requireDrmText)) form.append(`translations[${translation.language}][require_drm_text]`, translation.requireDrmText)
    });
  }

  if (socialLinks) {
    socialLinks.forEach(socialLink => {
      if (!isNullOrUndefined(socialLink.url)) form.append(`social_links[${socialLink.type}][url]`, socialLink.url);
    });
  }
  if (imageId) form.append("imageId", imageId);
  if (loginImageId) form.append("loginImageId", loginImageId);
  if (faviconId) form.append("faviconId", faviconId);
  if (binaryId) form.append("binaryId", binaryId);
  if (policyId) form.append("policyFileId", policyId);
  if (preRollVideoId) form.append("preRollVideoId", preRollVideoId);

  return form;
}

export const includeQuery = "include=image;preRollVideo;client.permissions;channelContentCreatorTypes.contentCreatorType.image;catalogs;translations;socialLinks;loginImage;faviconImage;tags;binary;policy;domain;tagGroups.types.contentCreatorType;trackingGroup";
